<div class="primary-font" *ngIf="noteFormGroup && user">
    <!-- Create Note -->
    <form [formGroup]="noteFormGroup" (submit)="submitNote()">
        <zuper-card class="flex flex-col w-full py-4 rounded-lg" *ngIf="options.config?.enableNewNote !== false"
            [ngClass]="{ 'note-small-screen': options.config?.renderSmallScreen === true }">
            <div class="text-xl font-semibold note-card-row-container"
                *ngIf="options.config?.showUserProfile !== false">
                {{'create.note.text' | translate}}</div>
            <div class="bg-white py-4 note-card-row-container">
                <div class="flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div class="ml-2 w-2/5">
                        <div class="flex items-center">
                            <div class="flex-shrink-0" matTooltip="{{user.first_name}} {{user.last_name ?? ''}}"
                                *ngIf="options.config?.showUserProfile !== false">
                                <img *ngIf="hasValidProfilePicture(user.profile_picture)"
                                    class="w-12 min-w-12 h-12 rounded-lg border" src="{{user.profile_picture}}"
                                    alt="{{user.first_name}} {{user.last_name || ''}}">
                                <div *ngIf="!hasValidProfilePicture(user.profile_picture) && user.first_name"
                                    class="flex items-center justify-center overflow-hidden uppercase text-3xl font-secondary bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 w-10 min-w-10 h-10 rounded-lg">
                                    {{user.first_name[0]}}
                                </div>
                            </div>
                            <div class="ml-4 w-3/4 primary-font">
                                <h3 class="text-lg font-medium leading-6 text-gray-900 truncate">{{user.first_name}}
                                    {{user.last_name || ''}}</h3>
                                <span class="text-secondary text-base truncate">{{user.designation || ''}}</span>
                            </div>
                        </div>
                    </div>
                    <!-- Note visibility -->
                    <ng-container
                        *ngIf="(showEditorActions === true || options.config?.editorOptions?.quickCreate !== false) && (options.config?.enablePrivacy !== false)">
                        <div class="mr-2 flex flex-shrink-0 primary-font">
                            <a mat-stroked-button [matMenuTriggerFor]="visibilityMenu"
                                class="inline-flex items-center pl-4 pr-3 py-3 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                                <em class="text-2xl mb-0.5 {{selectedVisibility.icon}}"></em>
                                <span class="ml-2">{{selectedVisibility.displayKey ? (selectedVisibility.displayKey |
                                    translate)
                                    :
                                    selectedVisibility.displayName}}</span>
                                <em class="text-xl" class="ti ti-chevron-down pl-2 text-base font-semibold"></em>
                            </a>
                            <mat-menu #visibilityMenu="matMenu">  
                                <div class="zuper-scrollbar">
                                    <ng-container *ngFor="let mode of visibilityOptions">
                                        <a mat-menu-item class="primary-font text-base h-10 text-gray-700 primary-font"
                                            *ngIf="mode?.showIf" (click)="selectVisibilityOptions(mode)">
                                            <em class="text-2xl mb-0.5 {{mode.icon}}"></em>
                                            <span class="ml-2">{{mode.displayKey ? (mode.displayKey | translate) :
                                                mode.displayName}}</span>
                                        </a>
                                    </ng-container>
                                </div>
                            </mat-menu>
                        </div>
                    </ng-container>
                </div>
            </div>
            <!-- <div class="items-start mt-2 w-full">
                        <div class="flex items-center mb-6 sm:mb-0 mr-3" matTooltip="{{user.first_name}} {{user.last_name ?? ''}}"
                            *ngIf="options.config?.showUserProfile !== false">
                            <img *ngIf="hasValidProfilePicture(user.profile_picture)" class="w-10 min-w-10 h-10 rounded-lg"
                                src="{{user.profile_picture}}" alt="">
                            <div *ngIf="!hasValidProfilePicture(user.profile_picture) && user.first_name"
                                class="flex items-center justify-center overflow-hidden uppercase text-3xl font-secondary bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 w-10 min-w-10 h-10 rounded-lg">
                                {{user.first_name[0]}}</div>
                        </div>
                    </div> -->
            <div class="flex mt-2 note-card-row-container">
                <mat-form-field class="zuper-mat-textarea zuper-mat-no-subscript w-full use-default-mat-height"
                    *ngIf="options.config?.editorOptions?.quickCreate !== false">
                    <textarea matInput formControlName="noteEditorData" id="noteEditorData_textarea" class="min-h-20"
                        [placeholder]="'notes.panel.editor.placeholder' | translate"></textarea>
                </mat-form-field>
                <div class="w-full mb-2 notes-editor-height" *ngIf="allowRenderEditor">
                    <text-editor [editorData]="noteFormGroup.controls?.noteEditorData" [options]="getEditorOptions()"
                        (editorFocus)="initEditor($event)" (attachmentsAdded)="attachmentsAdded($event)">
                    </text-editor>
                </div>
            </div>
            <p *ngIf="!noteFormGroup.valid && noteFormGroup.touched"
                class="note-card-row-container text-base mt-1 text-red-600">* {{"text.field_is_required" |
                translate}}</p>
            <!-- Notify To Users -->
            <div class="py-3 border-b note-card-row-container primary-font"
                *ngIf="((showEditorActions === true) || (options.config?.editorOptions?.quickCreate !== false)) && showNotifyUsersCheckbox">
                <div class="flex items-center mr-2">
                    <input id="notify_users" (change)="notifyUsers($event)" type="checkbox"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded cursor-pointer" checked>
                    <label for="notify_users"
                        class="ml-2 text-base font-medium text-gray-900 cursor-pointer pt-0.5">{{'notes.panel.notify_users.text'
                        |
                        translate}}</label>
                </div>
                <div *ngIf="(module === 'JOB')" class="ml-6 text-gray-500 text-base">{{'text.notes.job.notify_users.label' | translate}}</div>
                <div *ngIf="(module === 'PROJECT')" class="ml-6 text-gray-500 text-base">{{'text.notes.project.notify_users.label' | translate}}</div>
            </div>
            <!-- Associated With -->
            <div class="my-4 note-card-row-container primary-font"
                *ngIf="(showEditorActions === true || options.config?.editorOptions?.quickCreate !== false) && options.config?.enableNewAssociation">
                <div class="text-lg leading-6 font-medium pb-1">{{'notes.panel.sort.associated_with' | translate}}</div>
                <ng-container *ngIf="options?.defaultAssociatedModuleDetails">
                    <div [matTooltip]="getAssociatedModuleName(options.module, options?.defaultAssociatedModuleDetails)"
                        class="inline-flex items-center justify-between cursor-default mr-2 px-2.5 py-4 h-6 rounded-full text-base font-semibold mt-2 module-icon-color">
                        <em [ngClass]="getAssociatedModuleIcon(options.module)"
                            class="text-2xl font-medium mr-2 module-icon-color"></em>
                        <span class="truncate max-w-50 h-5">
                            {{getAssociatedModuleName(options.module, options?.defaultAssociatedModuleDetails)}}
                        </span>
                    </div>
                </ng-container>
                <ng-container *ngFor="let module of allModules">
                    <div *ngIf="associatedModules && checkModuleIsAssociated(module) && moduleKey[module] !== moduleKey[this.options.module]"
                        class="inline-flex items-center justify-between cursor-default mr-2 px-2.5 py-4 h-6 rounded-full text-base font-semibold mt-2 module-icon-color">
                        <div [matTooltip]="getAssociatedModuleName(module, associatedModules[paramKey[module]][0])" class="flex items-center justify-center">
                            <em [ngClass]="getAssociatedModuleIcon(module)"
                                class="text-2xl font-medium mr-2 module-icon-color"></em>
                            <span class="truncate max-w-50 h-5 mb-0.5 primary-font">
                                {{getAssociatedModuleName(module, associatedModules[paramKey[module]][0])}}
                            </span>
                        </div>
                        <div *ngIf="utilityService.hasModuleAccess(moduleKey[module], false, 'from_sidebar')" class="rounded-full cursor-pointer flex items-center justify-center ml-2 w-5 h-5 close-icon"
                            (click)="associatedModules[paramKey[module]] = undefined">
                            <em class="font-semibold ti ti-x text-sm"></em>
                        </div>
                    </div>
                </ng-container>
                <ng-container>
                    <div (click)="openAssociationsDrawer()"
                        class="inline-flex items-center cursor-pointer mr-2 px-3 py-4 h-6 rounded-full text-base font-semibold mt-2 module-icon-color">
                        <em class="ti ti-plus text-2xl font-medium module-icon-color"></em>
                    </div>
                </ng-container>
            </div>
            <!-- Attachments -->
            <ng-container *ngIf="options.config?.editorOptions?.quickCreate !== false && getFileAttachmentCount() > 0">
                <hr class="border-b my-4 note-card-row-container">
                <div class="flex flex-wrap note-card-row-container">
                    <ng-container *ngFor="let attachment of fileAttachments;let i=index">
                        <ng-container *ngIf="attachment?.attachment">
                            <file-placeholder class="file-container pr-1 my-1.5 max-w-full"
                                [options]="getPlaceholderOptions(attachment, true, false)"
                                (fileEventEmitter)="fileEventEmitHandler($event, i)">
                            </file-placeholder>
                        </ng-container>
                        <ng-container *ngIf="attachment?.name">
                            <div class="file-container flex p-2 mx-1 mt-2 items-center border rounded-lg">
                                <zuper-shimmer-loading class="w-10 h-10 file-shimmer-image">
                                </zuper-shimmer-loading>
                                <div class="flex flex-col ml-3 h-10 w-60">
                                    <a class="text-md font-medium truncate cursor-default primary-font">
                                        {{attachment.name}}
                                    </a>
                                    <zuper-shimmer-loading class="h-2.5 w-full file-shimmer-content">
                                    </zuper-shimmer-loading>
                                </div>
                                <button class="h-full -mt-5 cursor-pointer" (click)="cancelUploading(i)"
                                    matTooltip="{{'text.remove' | translate}}">
                                    <mat-icon class="text-2xl absolute -ml-2 -mt-8 text-red-400">cancel</mat-icon>
                                </button>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
            <span class="mt-2 text-red-600 text-base note-card-row-container primary-font"
                *ngIf="isReachedMaxAttachments()">{{'notes.attachment.maximum.alert' |
                translate}}</span>
            <div class="note-card-row-container mt-2">
                <div class="flex items-center -mx-3"
                    *ngIf="showEditorActions === true || options.config?.editorOptions?.quickCreate !== false">
                    <input type="file" class="hidden" accept="{{acceptedFileFormat}}" #postFileUpload multiple
                        (change)="onFileChange($event)">
                    <button type="button" class="px-3 mr-1" mat-button
                        *ngIf="options.config?.attachments?.isEnabled !== false"
                        (click)="options.config?.editorOptions?.quickCreate !== false ? postFileUpload.click() : openAttachments()">
                        <em class="ti ti-paperclip icon-size-5 mr-2 mb-1"></em>
                        <span class="text-base primary-font">{{getFileAttachmentCount() ? getFileAttachmentCount() + ' '
                            +
                            ('notes.panel.attachment.count_text'
                            |
                            translate) : ('notes.panel.attachment.text' | translate)}}</span>
                    </button>
                    <!-- <button class="px-3 mr-1" mat-button (click)="changeNoteType($event)"
                                                        *ngIf="options.config?.enablePrivacy !== false" matTooltip="{{(validateNoteType() ? 'notes.panel.tooltip.only_me' : 'notes.panel.tooltip.everyone') |
                                                    translate}}">
                                                        <mat-icon class="icon-size-5 mr-2"
                                                            [svgIcon]="validateNoteType() ? 'heroicons_solid:user' : 'heroicons_solid:users'"></mat-icon>
                                                        <span class="mt-0.5 text-base">{{(validateNoteType() ? 'text.only_me' : 'text.everyone') |
                                                            translate}}</span>
                                                    </button> -->
                    <div class="ml-auto px-4 flex items-center" *ngIf="options.config?.enablePrivacy !== false">
                        <em class="ti ti-info-circle text-xl text-primary cursor-pointer"
                            [matTooltip]="options.config?.renderSmallScreen === true ? ('notes.panel.visibility_info.' + (selectedVisibility.visibilityType | lowercase) | translate) : null"></em>
                        <span class="ml-2 text-lg font-medium primary-font"
                            *ngIf="!options.config?.renderSmallScreen">{{('notes.panel.visibility_info.' +
                            (selectedVisibility.visibilityType | lowercase)) |
                            translate}}</span>
                    </div>
                    <button type="submit"
                        class="primary-font h-10 min-h-10 mr-3 max-w-36 px-6 items-center py-2 border b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary"
                        mat-button>
                        <span class="text-base primary-font">{{'text.post_note' | translate}}</span>
                    </button>
                </div>
            </div>
        </zuper-card>
    </form>
    <div class="w-full flex justify-center mt-15" *ngIf="!loaded">
        <mat-spinner mode="indeterminate" [diameter]="40"></mat-spinner>
    </div>
    <!-- Notes Container -->
    <div class="" *ngIf="loaded && notes.length">
        <!-- Notes Sorting Menu -->
        <div class="flex my-5 mr-2" *ngIf="options.config?.sortOptions?.isEnabled !== false">
            <div class="flex space-x-2 items-center ml-auto cursor-pointer" [matMenuTriggerFor]="noteSortMenu">
                <em class="ti ti-align-left"></em>
                <div class="tetx-base primary-font">{{selectedSortOptionKey | translate}}</div>
                <em class="ti ti-chevron-down"></em>
            </div>
        </div>
        <mat-menu #noteSortMenu="matMenu">
            <button mat-menu-item class="h-10" *ngFor="let item of sortMenuItems" (click)="sortMenuClick(item)">
                <span class="flex items-center">
                    <span class="tetx-base primary-font">{{item.displayKey | translate}}</span>
                </span>
            </button>
        </mat-menu>
        <!-- Notes List Container -->
        <ng-container *ngFor="let note of notes">
            <zuper-card class="flex flex-col w-full my-4 rounded-lg">
                <div class="flex items-center mb-4" *ngIf="note.created_by_type !== 'CUSTOMER' && note.created_by"
                    [ngClass]="{ 'mx-4 sm:mx-4 mt-4': options.config?.renderSmallScreen === true, 'mx-6 sm:mx-8 mt-6': !options.config?.renderSmallScreen }">
                    <img *ngIf="hasValidProfilePicture(note.created_by.profile_picture)" loading="lazy"
                        class="w-11 h-11 rounded-lg mr-4 border" src="{{note.created_by.profile_picture}}"
                        alt="{{note.created_by.first_name}} {{note.created_by.last_name ?? ''}}">
                    <div *ngIf="!hasValidProfilePicture(note.created_by.profile_picture) && note.created_by.first_name"
                        class="flex items-center justify-center overflow-hidden uppercase text-3xl font-secondary bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 w-10 h-10 rounded-lg mr-4">
                        {{note.created_by.first_name[0]}}</div>
                    <div class="flex flex-col primary-font">
                        <div class="flex">
                            <span class="font-bold text-base leading-none">{{note.created_by.first_name}}
                                {{note.created_by.last_name ?? ''}}</span>
                        </div>
                        <span class="text-md text-secondary leading-none mt-2">{{note.created_by.designation}}</span>
                    </div>
                    <div class="ml-auto flex items-center justify-center">
                        <div class="flex items-center justify-center p-3 cursor-pointer"
                            *ngIf="isNoteModified(note)" [matTooltip]="note?.updated_at | datetime">
                            <span class="text-base text-gray-500 leading-none mt-1">{{'edited.text' | translate}}</span>
                        </div>
                        <div class="flex items-center justify-center p-3 rounded-full hover:bg-gray-200 cursor-pointer"
                            matTooltip="{{('notes.panel.visibility_info.' + (getNoteVisibility(note) | lowercase)) | translate}}">
                            <em class="ti icon-size-5"
                                [ngClass]="{'ti-lock': getNoteVisibility(note) === 'PRIVATE','ti-world': getNoteVisibility(note) === 'PUBLIC','ti-users': getNoteVisibility(note) === 'INTERNAL' }"></em>
                        </div>
                        <div class="flex items-center justify-center p-3 rounded-full hover:bg-gray-200 cursor-pointer"
                            *ngIf="note?.is_offline" [matTooltip]="note?.synced_at | datetime">
                            <em class="ti ti-cloud-off icon-size-5"></em>
                        </div>
                        <div class="flex items-center justify-center p-3 rounded-full hover:bg-gray-200 cursor-pointer"
                            [matMenuTriggerFor]="notePostMenu"
                            *ngIf="!options.config?.menuOptions?.deleteOnly && (isCurrentUser(note.created_by) || user?.role?.role_key === 'ADMIN')">
                            <em class="ti ti-dots-vertical icon-size-5"></em>
                        </div>
                        <div class="flex items-center justify-center p-3 rounded-full hover:bg-gray-200 cursor-pointer"
                            *ngIf="options.config?.menuOptions?.deleteOnly === true && (isCurrentUser(note.created_by) || user?.role?.role_key === 'ADMIN')"
                            matTooltip="{{'text.delete_note' | translate}}"
                            (click)="deleteNote($event, note)">
                            <em class="ti ti-trash icon-size-5 text-red-600"></em>
                        </div>
                    </div>
                    <mat-menu #notePostMenu="matMenu">
                        <!-- Change Privacy -->
                        <button mat-menu-item class="primary-font h-10" [matMenuTriggerFor]="privacyMenu">
                            <span class="flex items-center">
                                <em class="ti ti-shield-lock icon-size-5 mr-3 mb-1"></em>
                                <span class="text-base">{{'notes.panel.note.change_privacy' | translate}}</span>
                            </span>
                        </button>
                        <!-- Edit Note -->
                        <button mat-menu-item class="primary-font h-10"
                            *ngIf="!options.config?.editorOptions?.quickCreate" (click)="editNote(note)">
                            <span class="flex items-center">
                                <em class="ti ti-pencil icon-size-5 mr-3 mb-1"></em>
                                <span class="text-base">{{'text.edit_note' |
                                    translate}}</span>
                            </span>
                        </button>
                        <!-- Delete Note -->
                        <button mat-menu-item class="primary-font h-10" (click)="deleteNote($event, note)">
                            <span class="flex items-center note-delete-ele">
                                <em class="ti ti-trash icon-size-5 mr-3 mb-1"></em>
                                <span class="text-base">{{'text.delete_note' |
                                    translate}}</span>
                            </span>
                        </button>
                    </mat-menu>
                    <mat-menu #privacyMenu="matMenu">
                        <!-- Change to Public -->
                        <button mat-menu-item class="primary-font h-10" (click)="changeNoteMode($event, note, 'PUBLIC')"
                            *ngIf="getNoteVisibility(note) !== 'PUBLIC' && companyPolicy?.customer_portal_enabled">
                            <span class="flex items-center">
                                <em class="ti icon-size-5 mr-3 mb-1 ti-world"></em>
                                <span class="text-base">{{'notes.panel.visibility.public' | translate}}
                                </span>
                            </span>
                        </button>
                        <!-- Change to Internal -->
                        <button mat-menu-item class="primary-font h-10"
                            (click)="changeNoteMode($event, note, 'INTERNAL')"
                            *ngIf="getNoteVisibility(note) !== 'INTERNAL'">
                            <span class="flex items-center">
                                <em class="ti icon-size-5 mr-3 mb-1 ti-users"></em>
                                <span class="text-base">{{'notes.panel.visibility.internal' | translate}}
                                </span>
                            </span>
                        </button>
                        <!-- Change to Private -->
                        <button mat-menu-item class="primary-font h-10"
                            (click)="changeNoteMode($event, note, 'PRIVATE')"
                            *ngIf="getNoteVisibility(note) !== 'PRIVATE'">
                            <span class="flex items-center">
                                <em class="ti icon-size-5 mr-3 mb-1 ti-lock"></em>
                                <span class="text-base">{{'text.only_me' | translate}}
                                </span>
                            </span>
                        </button>
                    </mat-menu>
                </div>
                <div class="flex items-center mb-4" *ngIf="note.created_by_type === 'CUSTOMER' && note?.created_by_customer"
                    [ngClass]="{ 'mx-4 sm:mx-4 mt-4': options.config?.renderSmallScreen === true, 'mx-6 sm:mx-8 mt-6': !options.config?.renderSmallScreen }">
                    <ng-container *ngIf="note?.created_by_customer">
                        <div *ngIf="note?.created_by_customer?.customer_first_name"
                            class="flex items-center justify-center overflow-hidden uppercase text-3xl font-secondary bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 w-10 h-10 rounded-lg mr-4">
                            {{note?.created_by_customer?.customer_first_name?.[0]}}</div>
                        <div class="flex flex-col primary-font mr-2">
                            <div class="flex">
                                <span class="font-bold text-base leading-none">{{note?.created_by_customer?.customer_first_name}}
                                    {{note?.created_by_customer?.customer_last_name ?? ''}}</span>
                            </div>
                        </div>
                        <badge [options]="customerBadgeOptions"></badge>
                    </ng-container>
                    <div class="ml-auto flex items-center justify-center">
                        <div class="flex items-center justify-center p-3 rounded-full hover:bg-gray-200 cursor-pointer"
                            matTooltip="{{('notes.panel.visibility_info.' + (getNoteVisibility(note) | lowercase)) | translate}}">
                            <em class="ti icon-size-5 ti-world"></em>
                        </div>
                    </div>
                </div>
                <div class="mt-2 break-all tinymce-text-inner-html white-space-pre-line" style="white-space: pre-line" *ngIf="note.note || note.content"
                    [ngClass]="{ 'mx-4 sm:mx-4 mb-4': options.config?.renderSmallScreen === true, 'mx-6 sm:mx-8 mb-6': !options.config?.renderSmallScreen }"
                    [innerHTML]="(note.note ?? note.content) | safeHtml: false">
                </div>
                <hr class="border-b mx-4 sm:mx-4 mt-0 mb-3" *ngIf="note.note && note.attachments?.length">
                <div *ngIf="note.attachments && note.attachments.length" class="flex flex-col px-7 pb-6">
                    <div>
                        <span class="flex items-center">
                            <em class="ti ti-paperclip icon-size-5 mr-2 mb-1"></em>
                            <span class="primary-font text-base">{{note.attachments.length}}
                                {{'notes.panel.file.attachments' | translate}}</span>
                        </span>
                    </div>
                    <!-- Attachments -->
                    <ng-container *ngIf="!options.config?.attachments?.isGridLayout">
                        <div class="grid grid-cols-2 mt-3" *ngIf="note.attachments?.length">
                            <ng-container *ngFor="let attachment of note.attachments">
                                <file-placeholder class="my-2 pr-4 w-full"
                                    (click)="openGallery(note.attachments, attachment.attachment)"
                                    [ngStyle]="getCursorStyle(attachment.attachment)"
                                    [options]="getPlaceholderOptions(attachment, false, true)"
                                    (fileEventEmitter)="fileEventEmitHandler($event)">
                                </file-placeholder>
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="options.config?.attachments?.isGridLayout === true">
                        <div class="grid grid-cols-2 mt-3" *ngIf="getViewableAttachments(note.attachments)?.length">
                            <ng-container
                                *ngFor="let attachment of getViewableAttachments(note.attachments);let count=index">
                                <div class="p-1" (click)="openGallery(note.attachments, attachment.attachment)"
                                    *ngIf="count < 3" [ngStyle]="getCursorStyle(attachment.attachment)">
                                    <div class="flex items-center w-full h-52 relative">
                                        <div class="z-10 text-base flex h-7 w-full absolute text-white justify-center items-center cursor-pointer font-medium bg-gray-900 opacity-50"
                                            [ngClass]="{ 'bottom-0': getNoteAttachmentType(attachment.attachment) === 'IMAGE', 'top-0': getNoteAttachmentType(attachment.attachment) === 'VIDEO'}">
                                            <span
                                                class="primary-font truncate w-4/5 text-center">{{attachment.attachment_name}}</span>
                                        </div>
                                        <ng-container *ngIf="getNoteAttachmentType(attachment.attachment) === 'IMAGE'">
                                            <img class="w-full h-52 rounded-md overflow-hidden flex-shrink-0 object-contain note-file-bg-default"
                                                loading="lazy" src="{{attachment.attachment}}"
                                                alt="{{attachment.attachment_name ?? ''}}"
                                                *ngIf="attachment.attachment_size < 3000">
                                            <img class="w-full h-52 rounded-md overflow-hidden flex-shrink-0 object-contain note-file-bg-default"
                                                loading="lazy" src="assets/images/png/image_placeholder.png"
                                                alt="{{attachment.attachment_name ?? ''}}"
                                                *ngIf="attachment.attachment_size > 3000">
                                        </ng-container>
                                        <video controls controlsList="nodownload nofullscreen noremoteplayback"
                                            class="w-full h-52 rounded-md overflow-hidden flex-shrink-0 note-file-bg-default"
                                            *ngIf="getNoteAttachmentType(attachment.attachment) === 'VIDEO'">
                                            <source src="{{attachment.attachment}}" type="video/mp4">
                                            {{'text.video_unsupported' | translate}}
                                        </video>
                                    </div>
                                </div>
                                <div *ngIf="count === 3" class="p-1 rounded-md overflow-hidden flex-shrink-0"
                                    (click)="openGallery(note.attachments, attachment.attachment)">
                                    <div class="flex items-center w-full h-52 relative">
                                        <img class="rounded-md h-full overflow-hidden flex-shrink-0 note-file-cover-image object-contain note-file-bg-default"
                                            loading="lazy" src="{{attachment.attachment}}"
                                            alt="{{attachment.attachment_name ?? ''}}"
                                            *ngIf="getNoteAttachmentType(attachment.attachment) === 'IMAGE'">
                                        <video controls controlsList="nodownload nofullscreen noremoteplayback"
                                            class="rounded-md h-full overflow-hidden flex-shrink-0 note-file-cover-image note-file-bg-default"
                                            *ngIf="getNoteAttachmentType(attachment.attachment) === 'VIDEO'">
                                            <source src="{{attachment.attachment}}" type="video/mp4">
                                            {{'text.video_unsupported' | translate}}
                                        </video>
                                        <span
                                            class="text-xl flex items-center justify-center h-52 w-full absolute text-white cursor-pointer font-medium text-base primary-font">+
                                            {{getViewableAttachments(note.attachments)?.length - 3}}
                                            {{'text.more' | translate}}</span>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <div class="grid grid-cols-2" *ngIf="getNonViewableAttachments(note.attachments)?.length">
                            <ng-container *ngFor="let attachment of getNonViewableAttachments(note.attachments)">
                                <file-placeholder *ngIf="attachment" class="my-2 pr-4 w-full"
                                    [options]="getPlaceholderOptions(attachment, false, true)"
                                    (fileEventEmitter)="fileEventEmitHandler($event)">
                                </file-placeholder>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
                <!-- <hr class="border-b mx-4 sm:mx-4 mt-0 mb-3"> -->
                <div class="flex justify-between items-center"
                    [ngClass]="{ 'mx-4 sm:mx-4 mb-4': options.config?.renderSmallScreen === true, 'mx-6 sm:mx-8 mb-6': !options.config?.renderSmallScreen }">
                    <span class="text-lg text-secondary mt-2 flex items-center"><em
                            class="ti ti-clock-hour-4 text-2xl mr-2"></em><span>{{note.created_at |
                            datetime}}</span></span>
                    <button type="button" class="px-3 ml-auto -mr-2 text-info font-medium flex items-center"
                        (click)="openNoteDetails(note)" *ngIf="note.created_by_type !== 'CUSTOMER' && getAssociationsCount(note) > 0">
                        <em class="ti ti-link icon-size-5 mr-2 text-info font-medium mb-1"></em>
                        <span class="mt-0.5 text-base primary-font">{{getAssociationsCount(note)}}
                            {{'notes.panel.associations' | translate}}</span>
                    </button>
                </div>
            </zuper-card>
        </ng-container>
    </div>
    <div class="h-60 mt-6 flex flex-col items-center justify-center" *ngIf="loaded && !notes.length">
        <div class="flex flex-col items-center justify-center primary-font">
            <img class="w-40 m-auto" src="assets/images/svgs/add_comment.svg" alt="No Notes found">
            <h4 class="font-medium mt-4 text-secondary text-base primary-font">{{'notes.panel.notes.not_found' |
                translate}}</h4>
        </div>
    </div>

    <div *ngIf="showNotesTabLightGallery" style="width: 70%;">
        <lightgallery [settings]="settings" [onAfterAppendSubHtml]="lgAppendSubHTML" [onInit]="lightOnInit">
            <a href=""></a>
        </lightgallery>
    </div>
</div>